var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReturnedBag({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2082 14.3986L18.7252 13.1038C18.4654 12.8773 18.4379 12.4826 18.6653 12.2228C18.8918 11.963 19.2864 11.9364 19.5471 12.1629L22.2791 14.5476C22.414 14.6659 22.4922 14.8374 22.4922 15.0181C22.4922 15.1988 22.414 15.3703 22.2782 15.4886L19.5462 17.8725C19.4272 17.9758 19.2814 18.0265 19.1357 18.0265C18.9617 18.0265 18.7885 17.9541 18.6653 17.8126C18.4388 17.5528 18.4654 17.1581 18.7252 16.9316L20.1891 15.6543C18.0058 15.72 16.248 17.5428 16.248 19.786V21.3756C16.248 21.7203 15.9682 22.0001 15.6235 22.0001C15.2788 22.0001 14.9982 21.7211 14.9982 21.3764V19.7868C14.9982 16.8466 17.3263 14.4527 20.2082 14.3986Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1854 2.0166L6.13859 2.03326C5.61401 2.03326 5.12273 2.32469 4.87293 2.78266L2.75793 6.61296L9.77738 6.59631L10.1854 2.0166Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8955 6.57971L16.7555 2.74941C16.4974 2.29144 16.0144 2 15.4815 2L11.4347 2.01665L11.8594 6.59636L18.8955 6.57971Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1618 10.3433H19.1368C18.4707 10.3433 17.8462 10.6264 17.4132 11.126C17.0052 11.5923 16.8053 12.1752 16.847 12.7914C16.872 13.0578 16.9386 13.3243 17.0385 13.5658C15.1566 14.59 13.7744 16.4635 13.4247 18.6701L3.84893 18.695C3.84061 18.695 3.84061 18.695 3.84061 18.695C3.12451 18.695 2.53331 18.1038 2.53331 17.3794L2.5 7.86195L10.2022 7.84529H11.4512L19.1535 7.82031L19.1618 10.3433Z"
  })));
}

export default SvgReturnedBag;